import { Provider } from 'react-redux';
import { HEADER_NAV_MENU } from '@doda/pc/src/constants/headerNavMenu';
import { BasicLayout } from '@doda/pc/src/components/layouts/BasicLayout';
import { PageViewAnalytics } from '@doda/common/src/components/JobContent/PageViewAnalytics';
import {
  PAGE_NAME_PC,
  CHANNEL,
} from '@doda/common/src/constants/seo/jobTrendConstants';
import { InferGetServerSidePropsType } from 'next';
import { makeStore } from 'redux/store';
import { JobTrendScreen } from './screens/JobTrendScreen';
import { getServerSideProps } from './getServerSideProps';

const JobTrend = (
  props: InferGetServerSidePropsType<typeof getServerSideProps>
) => {
  const { targetName, isLogin, breadcrumbData, initialState } = props;
  const store = makeStore({ preloadedState: initialState });

  return (
    <Provider store={store}>
      <BasicLayout
        selectedNavItem={HEADER_NAV_MENU.SEARCH}
        leadSentence={`${targetName} doda掲載中求人の傾向`}
      >
        <PageViewAnalytics pageName={PAGE_NAME_PC} channel={CHANNEL} />
        <JobTrendScreen
          targetName={targetName}
          isLogin={isLogin}
          breadcrumbData={breadcrumbData}
        />
      </BasicLayout>
    </Provider>
  );
};

export { getServerSideProps };

export default JobTrend;
